module.exports = __webpack_public_path__ + "img/logo-b-fiolet.32b0bac4.png";